import api from '../services/api';
import axios from 'axios';

class TokenExpirationChecker {
  constructor() {
    this.interval = null;
    this.isChecking = false;
  }

  // Start checking token expiration every 5 minutes
  startChecking(onTokenExpired) {
    if (this.interval) {
      this.stopChecking();
    }

    console.log('Starting token expiration checker - checking every 5 minutes');
    
    // Check immediately
    this.checkTokenExpiration(onTokenExpired);
    
    // Then check every 5 minutes (since tokens last 7 days)
    this.interval = setInterval(() => {
      this.checkTokenExpiration(onTokenExpired);
    }, 5 * 60 * 1000); // 5 minutes
  }

  // Stop checking token expiration
  stopChecking() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      console.log('Stopped token expiration checker');
    }
  }

  // Check token expiration by calling the API
  async checkTokenExpiration(onTokenExpired) {
    if (this.isChecking) {
      return; // Prevent multiple simultaneous checks
    }

    this.isChecking = true;

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.log('No token found, stopping expiration checker');
        this.stopChecking();
        return;
      }

      console.log('Checking token expiration...');
      
      const response = await api.get('/api/auth/check-token-expiration');
      
      if (response.data.expired) {
        console.log('Token has expired, logging out user');
        this.stopChecking();
        
        if (onTokenExpired && typeof onTokenExpired === 'function') {
          onTokenExpired();
        }
      } else {
        const minutesLeft = response.data.tokenInfo.minutesLeft;
        console.log(`Token is valid, expires in ${minutesLeft} minutes`);
        
        // If token expires in less than 1 hour, show warning
        if (minutesLeft <= 60) { // 1 hour = 60 minutes
          console.warn(`Token will expire soon (${minutesLeft} minutes left)`);
        }
      }

    } catch (error) {
      console.error('Error checking token expiration:', error);
      
      // If we get a 401, the token is invalid/expired
      if (error.response && error.response.status === 401) {
        console.log('Token is invalid/expired, logging out user');
        this.stopChecking();
        
        if (onTokenExpired && typeof onTokenExpired === 'function') {
          onTokenExpired();
        }
      }
    } finally {
      this.isChecking = false;
    }
  }

  // Manual check (can be called from other parts of the app)
  async manualCheck(onTokenExpired) {
    await this.checkTokenExpiration(onTokenExpired);
  }
}

// Create a singleton instance
const tokenExpirationChecker = new TokenExpirationChecker();

export default tokenExpirationChecker; 